import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import styled from 'styled-components'
import { LabellessCheckbox } from '@chegg-ui/checkbox'
import { themeBreakPoints } from '@chegg-wt/core/theme/theme'
import { BodySmallGray } from '@chegg-wt/core/theme/sunkist/typography'

export const BaseProjectItem = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.greyDark};
  border: ${({ theme }) => `1px solid ${theme.colors.greyDDD}`};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 6px;
  font-size: ${({ theme }) => theme.font.text.size.lg};
  margin: 5px 0px;
`

export const ProjectDateText = styled.span`
  ${BodySmallGray};
`

export const ProjectListItem = styled(BaseProjectItem)`
  padding: 0px 10px;
  height: 56px;
  justify-content: space-between;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);

  &:hover,
  &:focus-within {
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.4);
  }
  & > * {
    min-width: 0;
  }
  & > :first-child {
    flex: 0 0 auto;
  }
`

export const Content = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  & > * {
    min-width: 0;
    flex: 0 0 auto;
  }
  & > :first-child {
    flex: 1 1 auto;
  }
  @media (max-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const BaseCheckBox = styled.input`
  -webkit-appearance: none;
  background-size: 20px 20px;
  height: 20px;
  width: 20px;
`

export const ProjectItemCheck = styled(LabellessCheckbox)``

export const ProjectItemStar = styled(BaseCheckBox)`
  cursor: pointer;
  background: ${`url('${publicAssetUrl('starred.svg')}') no-repeat;`};
  &:checked {
    background: ${`url('${publicAssetUrl('star-selected.svg')}') no-repeat;`};
  }
  &:hover,
  &:focus-within {
    background: ${`url('${publicAssetUrl('star-selected.svg')}') no-repeat;`};
  }
`

export const Controls = styled.div`
  display: flex;
  width: 55px;
  margin-right: 20px;
  align-items: center;
  justify-content: space-between;
  input {
    cursor: pointer;
    margin-top: 0;
  }
  @media (max-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
    flex-direction: column;
    width: auto;
    height: 55px;
    input {
      margin: 0 0;
    }
  }
`
